import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  templateOverridesList: [],
  templateOverridesLoading: false,
};

const templateOverridesSlice = createSlice({
  name: 'templateOverridesSlice',
  initialState,
  reducers: {
    templateOverridesListSlice: (state, { payload }) => {
      state.templateOverridesList = payload;
    },
    templateOverridesLoadingSlice: (state, { payload }) => {
      state.templateOverridesLoading = payload;
    },
  },
});

const { actions, reducer } = templateOverridesSlice;

export const { templateOverridesListSlice, templateOverridesLoadingSlice } =
  actions;

export default reducer;
